"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Experiment_1 = __importDefault(require("./Experiment"));
var ExperimentProviderContext_1 = __importDefault(require("../ExperimentProviderContext"));
var assignFalsy = function (values) {
    var n = values.shift();
    return n || n === 0 || n === false ? n : assignFalsy(values);
};
var ExperimentContainer = /** @class */ (function (_super) {
    __extends(ExperimentContainer, _super);
    function ExperimentContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExperimentContainer.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(ExperimentProviderContext_1.default.Consumer, null, function (providerState) {
            var _a = providerState || {}, _b = _a.defaults, defaults = _b === void 0 ? {} : _b, restOfState = __rest(_a, ["defaults"]);
            var _c = _this.props, identifier = _c.identifier, environment = _c.environment, cacheMinutes = _c.cacheMinutes, restOfProps = __rest(_c, ["identifier", "environment", "cacheMinutes"]);
            var expState = __assign(__assign(__assign({}, restOfState), restOfProps), { identifier: identifier || defaults.identifier || '', environment: environment || defaults.environment || process.env.NODE_ENV, cacheMinutes: assignFalsy([
                    cacheMinutes,
                    defaults.cacheMinutes,
                    15
                ]), killSwitch: defaults.killSwitch || 'off' });
            return react_1.default.createElement(Experiment_1.default, __assign({}, expState));
        }));
    };
    return ExperimentContainer;
}(react_1.PureComponent));
ExperimentContainer.contextType = ExperimentProviderContext_1.default;
exports.default = ExperimentContainer;
